<template>
  <div>
    <Table border :columns="columns1" :data="data1"></Table>
    <br />
    <Page
        :total="total"
        show-total
        @on-change="changePage"
        @on-page-size-change="changePagesize"
    />
    <Modal title="多图预览" v-model="imgVisibles">
      <div style="height: 620px; overflow-y: auto ;">
        <div style="text-align: center">
          <img
              :src="loadimg(v)"
              v-for="(v, k) in imgUrls"
              :key="k"
              style="width: 420px"
          />
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  props: {
    workId: {
      type: String,
      value: "",
    },
  },
  data() {
    return {
      // imgVisibles:false,
      columns1: [
        {
          title: "送修零件",
          minWidth: 100,
          key: "sendPart",
          align: "center",
        },
        {
          title: "送修地点",
          minWidth: 110,
          key: "sendSite",
          align: "center",
        },
        {
          title: "预计费用",
          minWidth: 100,
          key: "cost",
          align: "center",
        },
        {
          title: "凭证上传",
          key: "imgUrl",
          minWidth: 250,
          align: "center",
          lign: "left",
          render:(h,params)=>{
            let imgArr=[];
            let dom = null
            dom =  h('div',[
              // 插入多张图片
              params.row.imgUrl.split(",").forEach(url => {
                imgArr.push(h('img',{
                  attrs:{
                    src:url
                  },
                  style:{
                    width:'100px',
                    height:'200px',
                  }
                }));
              }),
              h('span',{

              },imgArr)
            ])
            return dom
          },
        },
        {
          title: "备注",
          minWidth: 120,
          align: "center",
          key: "remark",
        },
        {
          title: "送修人",
          minWidth: 90,
          key: "sendName",
          align: "center",
        },
        {
          title: "预计完成时间",
          minWidth: 170,
          align: "center",
          key: "finishTime",
        },
        {
          title: "送修时间",
          minWidth: 170,
          align: "center",
          key: "sendTime",
        },
      ],
      data1: [],
      total: this.total,
    };
  },
  created() {
  },
  mounted() {
    if (this.workId) {
      this.load(this.workId);
    }
  },
  methods: {
    showBigPic(item) {
      this.bigPicVisible = true;
      this.bigPicUrl = item;
    },
    load(workId, page = 1) {
      let q = {};
      // let a = {}
      // a.workId = workId
      q.workId = workId;
      // q.page = page
      q.pageSize = 10;
      q.pageNum = page;
      $utils.api
          .load("/admin/system/send/list", q)
          .then((res) => {
            if (res.code > 0) {
              let data = res.rows;
              let list = data || [];
              this.data1 = list;
              this.total = res.total;
            }
          })
          .catch(() => {
            $utils.toast.error("请求错误");
          });
    },
    changePage(p) {
      this.load(this.workId, p);
    },
    changePagesize(psize) {
    },
  },
};
</script>
